import { SimNaoEnum } from 'components/form'

import { ExemplosPassouFalhouVerticalFieldModel } from '../../components/ExemplosPassouFalhouVerticalField'
import { ConsultaSeguimentoAplicacaoItemModel, PassouFalhouEnum } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta01ExemplosEnum {
  OLHA_PARA_OBJETO = 'OLHA_PARA_OBJETO',
  APONTA_PARA_OBJETO = 'APONTA_PARA_OBJETO',
  OLHA_E_COMENTA_SOBRE_OBJETO = 'OLHA_E_COMENTA_SOBRE_OBJETO',
  OLHA_QUANDO_GENITOR_APONTA = 'OLHA_QUANDO_GENITOR_APONTA',
  IGNORA_VOCE = 'IGNORA_VOCE',
  OLHA_AO_REDOR = 'OLHA_AO_REDOR',
  OLHA_PARA_DEDO_DO_GENITOR = 'OLHA_PARA_DEDO_DO_GENITOR',
}

export interface ConsultaSeguimentoPergunta01Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_01_HEADER?: SimNaoEnum
  PERGUNTA_01_EXEMPLOS?: ExemplosPassouFalhouVerticalFieldModel<ConsultaSeguimentoPergunta01ExemplosEnum>
  PERGUNTA_01_MAIOR_FREQUENCIA?: PassouFalhouEnum
}
